module.exports = __webpack_public_path__ + "img/JT_icons01_64px_EliteOff.591847e1.svg";